/* TradeTidy — keeps the "Bundle and save" cart bar on collection pages in view.
   position:sticky can't be used because the bar lives inside the hero section, which
   ends right after it. Instead, once the bar would scroll under the sticky header it is
   switched to position:fixed (a placeholder keeps the page from jumping), and released
   again when the main content has scrolled past. */
(function () {
  var bar = document.querySelector(".tt-cart-progress");
  if (!bar) return;

  var main = document.getElementById("MainContent");
  var placeholder = document.createElement("div");
  placeholder.className = "tt-cart-progress-placeholder";
  bar.parentNode.insertBefore(placeholder, bar);

  var stuck = false;
  var ticking = false;

  function headerOffset() {
    var sticky = document.querySelector("sticky-header:not([disabled])");
    var header = document.querySelector(".section-header");
    if (!sticky || !header) return 0;
    var covering =
      (header.classList.contains("section-header-sticky") ||
        header.classList.contains("section-header-sticky-always")) &&
      !header.classList.contains("section-header-hidden");
    return covering ? sticky.offsetHeight : 0;
  }

  function update() {
    ticking = false;
    var off = headerOffset();
    var gap = 8;
    var anchorTop = placeholder.getBoundingClientRect().top; // where the bar naturally sits
    var shouldStick = anchorTop < off + gap;

    if (shouldStick && main) {
      // Let go once the product grid has scrolled away (don't float over the footer).
      var mainBottom = main.getBoundingClientRect().bottom;
      if (mainBottom < off + gap + bar.offsetHeight + 40) shouldStick = false;
    }

    if (shouldStick !== stuck) {
      stuck = shouldStick;
      if (stuck) placeholder.style.height = bar.offsetHeight + "px";
      bar.classList.toggle("is-stuck", stuck);
      if (!stuck) {
        placeholder.style.height = "0px";
        bar.style.top = "";
        bar.style.left = "";
        bar.style.width = "";
      }
    }

    if (stuck) {
      var rect = placeholder.getBoundingClientRect();
      bar.style.top = off + gap + "px";
      bar.style.left = rect.left + "px";
      bar.style.width = rect.width + "px";
    }
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener("scroll", request, { passive: true });
  window.addEventListener("resize", request);
  // The header reveals/hides itself by class while scrolling; follow it.
  var header = document.querySelector(".section-header");
  if (header && window.MutationObserver) {
    new MutationObserver(request).observe(header, { attributes: true, attributeFilter: ["class"] });
  }
  // The bar's own height changes when the Turbo tiers finish loading.
  if (window.ResizeObserver) {
    new ResizeObserver(function () {
      if (stuck) placeholder.style.height = bar.offsetHeight + "px";
      request();
    }).observe(bar);
  }
  update();
})();
